<template>

<core-panel>

	<template v-slot:head>

		<h1>{{ name }}</h1>

		<p><b>{{ games.length }}</b> <plural t="game" :n="games.length" /> in your universe with this {{ attrType }}.</p>

	</template>

	<template v-slot:body>

		<app-game v-for="(item, index) in games" :key="index" :item="gameItem(item)" :tags="tags(item)" :dark="item.isThis" :show-plays-text="true" v-on:click.native="goToGame(item.id)" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'attribute',
			params: ['attrType', 'attrId'],
			games: [],
			name: '',
			attrType: ''
		}

	},

	methods: {

		response: function(json) {

			this.name = json.attribute.name
			this.attrType = json.attribute.type
			this.games = json.attribute.games

		},

		gameItem: function(item) {

			return {
				id: item.id,
				rating: item.rating || 0,
				plays: item.plays || 0
			}

		},

		tags: function(item) {

			var t = []

			if (item.owned) t.push({ blue: true, text: 'Own' })
			if (item.prevowned) t.push({ red: true, text: 'Prev Owned' })
			if (item.wishlisted) t.push({ red: true, text: 'Wishlisted' })
			if (item.rated) t.push({ green: true, text: 'Rated' })
			if (item.played) t.push({ blue: true, text: 'Played' })

			return t.length ? t : undefined

		},

		goToGame: function(id) {

			this.$router.push({ name: 'InsightsGame', params: { game: id } })
			this.$pubsub.$emit('panel.close')

		}

	}

}

</script>
